import yaMetrics from "./counters/yaMetrika";
const AnalyticManagerClass = (() => {
    const config = {};
    const events = {};
    const globalParams = {};
    return {
        /**
         * Глобальные опции для метрик
         * @param options
         */
        config: (options) => {
            let vendor;
            for (vendor in options) {
                if (!(vendor in config)) {
                    config[vendor] = {};
                }
                config[vendor] = {
                    ...config[vendor],
                    ...options[vendor],
                };
            }
        },
        /**
         * Работа с внутренним общим хранилищем, которые отправляются с каждым событием
         * @param params передача параметра со значением `null` используется для удаления из хранилища
         */
        globalParams: (params) => {
            const next = {};
            let k;
            for (k in params) {
                if (params[k]) {
                    next[k] = params[k];
                }
                else {
                    if (params[k] === null) {
                        delete globalParams[k];
                    }
                }
            }
            Object.assign(globalParams, next);
        },
        /**
         * Добавление новых событий
         * @param newEvents
         */
        events: (newEvents) => {
            Object.assign(events, newEvents);
        },
        /**
         * Отправка события в метрики
         * @param name имя события
         * @param params кастомные параметры к текущему событию
         */
        send: (name, params = {}) => {
            const currentEvents = [];
            if (name in events) {
                currentEvents.push(events[name]);
            }
            for (const event of currentEvents) {
                for (const item in event) {
                    switch (item) {
                        case "ya": {
                            const vendorParams = config.ya || {};
                            yaMetrics({
                                ...vendorParams,
                                ...globalParams,
                                ...event[item],
                                ...params,
                                timestamp: Date.now(),
                            });
                            break;
                        }
                    }
                }
            }
        },
    };
})();
export const AnalyticManager = Object.freeze(AnalyticManagerClass);
